import { defaultProps } from "./defaultProps";

export default class Animation {
    constructor(props) {
        this.props = props;
    }

    computeAnimateTransition(slideIndex, contentStyle, carouselRef) {
        const style = this.computeTransition(slideIndex, contentStyle, carouselRef);
        // Add inline animation transition CSS to slides container
        style.transition = defaultProps.transition;

        return style;
    }

    computeTransition(slideIndex, contentStyle, carouselRef) {
        const { slideWidth, slideMargin } = Animation.calculateSlideWidth(carouselRef);
        //Dealing with the one pixel problem.
        //Browsers cannot render less than one pixel so whenever we provide .x px;
        //Browsers around that number to show whole number of pixels.
        //Here we make sure that no one pixel strip from the previous slide is seeing on the next one
        const correction = 0.5;

        const transition = (slideIndex + 1) * (slideWidth + slideMargin) + correction;
        const style = Object.assign({}, contentStyle);

        // Add inline transition CSS to slides container
        const slideDirection = this.props.verticalSlideDirection ? "translateY" : "translateX";
        style.transform = `${slideDirection}(${-transition}px)`;
        style.transition = defaultProps.transitionNone;

        return style;
    }

    static calculateSlideWidth(carouselRef) {
        let slideWidth = 0,
            slideMargin = 0;
        if (carouselRef && carouselRef.current) {
            const carouselWrapper = carouselRef.current;
            const slide = carouselWrapper.querySelector(".tq-slide");
            slideWidth = window.getComputedStyle(slide).width;
            slideWidth = +slideWidth.substring(0, slideWidth.length - 2);
            slideMargin = window.getComputedStyle(slide).marginLeft;
            slideMargin = +slideMargin.substring(0, slideMargin.length - 2);
        }
        return { slideWidth, slideMargin };
    }
}
